import { isArgId } from '@blaze-shared/api-contracts-domain';
import { type DatasetColumn } from '@blaze-shared/schema-domain';

/**
 * Function input parameters are stored in the inputParams schema with ArgIds instead of ColumnIds.
 * Autocomplete should show a human-readable label for those entries.
 */
export function getNamedInputColumnDisplay(col: DatasetColumn): string | undefined {
  if (isArgId(col.id)) {
    return `Input Parameter | ${col.name ?? col.id}`;
  }
  return undefined;
}
